import { render, staticRenderFns } from "./riskQuesDc.vue?vue&type=template&id=8c97aa96"
import script from "./riskQuesDc.vue?vue&type=script&lang=js"
export * from "./riskQuesDc.vue?vue&type=script&lang=js"
import style0 from "./riskQuesDc.vue?vue&type=style&index=0&id=8c97aa96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports